/**
 * index.tsx
 *
 * This is the entry file for the application, only setup and boilerplate
 * code.
 */

import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import * as React from 'react';
import { ThemeProvider } from 'styled-components';

// Use consistent styling
import 'sanitize.css/sanitize.css';

// Import root app
import { App } from 'app';
import { HelmetProvider } from 'react-helmet-async';
import { createRoot } from 'react-dom/client';
import reportWebVitals from 'reportWebVitals';

// Initialize languages
import './locales/i18n';

const theme = {
    palette: {
        gray: {
            0: '#f4f4f5',
            50: '#f9fafb',
            100: '#f3f4f6',
            200: '#e5e7eb',
            300: '#d2d4dc',
            400: '#9ca3af',
            500: '#6b7280',
            600: '#4b5563',
            // 700
            // 800
            900: '#111928',
        },
        red: {
            500: '#e02424',
        },
    },
    fontSize: {
        small: '12px',
        default: '16px',
    },
    borderRadius: {
        small: '5px',
        medium: '10px',
        default: '16px',
        large: '25px',
    },
};

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript

root.render(
    <ThemeProvider theme={theme}>
        <HelmetProvider>
            <React.StrictMode>
                <App />
            </React.StrictMode>
        </HelmetProvider>
    </ThemeProvider>,
);

// Hot reloadable translation json files
if (module.hot) {
    module.hot.accept(['./locales/i18n'], () => {
        // No need to render the App again because i18next works with the hooks
    });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
